import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.ProductSlip || initialState;

const makeProductSlipSelectField = (field) =>
  createSelector(reducerState, (productSlipState) => productSlipState[field]);

const productSlipStatusList = () =>
  createSelector(() => {
    const orderStatus = [
      { label: "Uploaded", value: "1", color: "light" },
      { label: "Confirmed", value: "2", color: "gray" },
      { label: "Dispatched", value: "3", color: "dark" },
      { label: "Delivered", value: "4", color: "green" },
      { label: "Cancelled", value: "5", color: "red" },
    ];
    return orderStatus;
  });
export { reducerState, makeProductSlipSelectField, productSlipStatusList };
